/**
 * Registers the app-shell worker. Production builds only: the dev and preview
 * servers have no /sw.js and their chunks are not content-hashed.
 */
export function registerShellWorker(): void {
	if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;
	// After load, so the worker's precache downloads never compete with the first paint.
	addEventListener("load", () => {
		// Offline-only polish: a failed registration leaves the app exactly as it was.
		navigator.serviceWorker.register("/sw.js").catch(() => undefined);
	});
}
